import React from 'react';
import Markdown from './Markdown';
function Present() {
    return (
        <div>
            <br></br>
            <Markdown/>
        </div>
    )
}

export default Present
